import { StandardEvents } from '@shopify/events';

class StockDispatchMessage extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    this.#abortController = new AbortController();
    const target = this.closest('.shopify-section, dialog');
    target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #handleProductSelect = (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.productId && detail.productId !== this.dataset.productId) return;

        const selector = `stock-dispatch-message[data-block-id="${this.dataset.blockId}"]`;
        const updatedMessage = detail.html.querySelector(selector);
        if (updatedMessage) this.replaceWith(updatedMessage.cloneNode(true));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[stock-dispatch-message] Variant update failed:', error);
      });
  };
}

if (!customElements.get('stock-dispatch-message')) {
  customElements.define('stock-dispatch-message', StockDispatchMessage);
}
